module.exports = __webpack_public_path__ + "static/media/presentationProf.a5f232ab.png";